var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { DateLib } from "@@/Datelib";
import { SearchDataType } from "@@/ModuleJob";
import { ProjectObjectType } from "@@/Project";
import { formatBytes, isIpadScreen, testIsMobile } from "@@/Util";
import { makeObservable, observable, action } from "mobx";
import { ROOTFolder } from "../const/AppDefaults";
import { ExpandableTreeState } from "../UIComponents/ExpandableTree";
import { TableRenderState } from "./TableRenderState";
import { FilterDialogState } from "../UIComponents/FilterDialogState";
export class ObjectChooserState {
    constructor() {
        this.projectsobject = new Map();
        this.show = false;
        this.searchterm = "";
        this.folders = new Map();
        this.searchstore = new Map();
        this.activeview = "no-access";
        this.width = isIpadScreen() || testIsMobile() ? window.innerWidth - 20 : window.innerWidth / 2;
        this.left = isIpadScreen() ? 20 : 100;
        this.top = 100;
        this.dragging = false;
        this.projectobjectsByFolderId = new Map();
        this.activeletrid = "";
        this.activefolderid = "";
        this.loadedfolder = -1;
        this.loadingfolders = false;
        this.loadingfoldercontent = false;
        this.showsearchresult = false;
        this.searchactive = false;
        this.filterfolderterm = "";
        this.foundmsg = "";
        this.loadingmoresearch = false;
        this.showaddlinkbtn = false;
        this.searchmatches = [];
        this.atimeout = undefined;
        this.searching = false;
        this.searchprogressmessage = "";
        this.documentTableState = new TableRenderState();
        this.singlemode = false;
        this.projecttreestate = new ExpandableTreeState();
        this.metaitems = new Map();
        this.showcolview = false;
        this.hidecoilumn = new Set();
        this.showfilter = false;
        this.cview = [];
        this.activeitemid = "";
        this.selectionmode = false;
        this.filterdialogstate = new FilterDialogState();
        this.showfolderchooser = false;
        this.reportview = false;
        makeObservable(this);
        this.addHeaders();
        APPEvent.addSubscriberForProjectFolders((folder) => {
            if (folder.letrid === this.activeletrid && folder.isChooser) {
                this.setFolders(folder.folders);
            }
        });
        APPEvent.addSubscriberForSearchMatchResp((res) => {
            if (this.searching && res.letrid === this.activeletrid && res.searchtext === this.searchterm) {
                if (res.matches === undefined) {
                    this.documentTableState.clearRows();
                    this.projecttreestate.hideAll();
                    this.setSearching(false);
                    this.setSearchFoundMessage("No matches");
                }
                else {
                    const pids = new Set();
                    for (const re of res.matches.result) {
                        for (const d of re.indexdata) {
                            pids.add(d.itemid);
                        }
                    }
                    if (pids.size === 0) {
                        this.documentTableState.clearRows();
                        this.projecttreestate.hideAll();
                        this.setSearching(false);
                        this.setSearchFoundMessage("No matches");
                    }
                    else {
                        this.setSearchFoundMessage(pids.size + " match" + (pids.size > 1 ? "es" : ""));
                        // we should fist download all the parents and then maybe we should show the result
                        this.downloadParentForObjects(Array.from(pids));
                        this.searchmatches = Array.from(pids);
                    }
                }
            }
        });
        APPEvent.addSubscriberForObjectParentFolder((res) => {
            if (this.searching && res.letrid === this.activeletrid && res.id === this.searchterm) {
                // now we have everything to display our result
                // we need to hide all folders and only show the parent tree stuff
                // on click we can just display the matching reuslt 
                this.setActiveFolderId("");
                this.documentTableState.clearRows();
                this.projecttreestate.hideAll();
                this.showSearchParentResult(res.parent);
                this.setSearching(false);
            }
        });
        APPEvent.addSubscriberForProjects((prjs) => {
            if (this.loadingfoldercontent && prjs.isChooser) {
                if (this.activeletrid === prjs.letrid && this.activefolderid === prjs.parentid) {
                    this.addProjectObjects(prjs.projects);
                    this.addProjectObjectsByFolder(prjs.projects, this.activefolderid);
                    this.setLoadingFolderContent(false);
                }
            }
        });
        APPEvent.addSubcriberForGetMetadataa((res) => {
            if (!res.isChooser) {
                return;
            }
            const meta = res.data;
            this.clearMetadata();
            for (const mt of meta) {
                if (mt.letrid === this.activeletrid) {
                    this.addMetadata(mt);
                }
            }
            this.addHeaders();
        });
        APPEvent.addSubscriberForActiveLetr((lt) => {
            this.activeletrid = lt;
        });
    }
    setReportView(show) {
        this.activeview = 'datasheet';
        this.reportview = show;
    }
    setShowFolderChooser(show) {
        this.showfolderchooser = show;
    }
    hideCol(id) {
        this.hidecoilumn.add(id);
        this.addHeaders();
    }
    showCol(id) {
        this.hidecoilumn.delete(id);
        this.addHeaders();
    }
    setActiveItemid(id) {
        this.activeitemid = id;
        // this.setLoadingInitObject(false);
        // this.initobjectid = "";
        // this.initnoteid = "";
        if (!id) {
            this.documentTableState.setSelectId("");
        }
    }
    addHeaders() {
        this.documentTableState.clearHeaders();
        const rows = this.documentTableState.getRows();
        this.documentTableState.clearRows();
        this.documentTableState.addHeaders([
            { label: 'Name', id: 'name', index: 0, width: (window.innerWidth * .75) / 2 },
            { label: 'Type', id: 'type', index: 1, width: (window.innerWidth * .75 / 2) / 3.2 },
            { label: 'Size', id: 'size', index: 2, width: (window.innerWidth * .75 / 2) / 3.2 },
            { label: 'Last Modified', id: 'lastmodified', index: 3, width: window.innerWidth * .75 / 2 / 3.2 }
        ].filter((sh) => !this.hidecoilumn.has(sh.id)));
        if (this.metaitems.size > 0) {
            const mitems = this.getMetadata();
            this.documentTableState.addHeaders(mitems.filter((mitem) => !this.hidecoilumn.has(mitem.id)).map((mitem, index) => {
                const ret = {
                    label: mitem.name,
                    id: "custom_" + mitem.id,
                    index: index + 4,
                    width: 400
                };
                return ret;
            }));
        }
        this.addColumnViews();
        this.addProjectObjects(Array.from(this.projectsobject.values()));
    }
    addColumnViews() {
        var _a, _b, _c, _d;
        const lcopy = this.cview;
        this.cview.splice(0, this.cview.length);
        const lmap = new Map();
        lcopy.forEach((lc) => lmap.set(lc.id, lc.hidden));
        const sview = [{ label: 'Name', id: 'name', hidden: (_a = lmap.get("name")) !== null && _a !== void 0 ? _a : false },
            { label: 'Type', id: 'type', hidden: (_b = lmap.get("type")) !== null && _b !== void 0 ? _b : false },
            { label: 'Size', id: 'size', hidden: (_c = lmap.get("size")) !== null && _c !== void 0 ? _c : false },
            { label: 'Last Modified', id: 'lastmodified', hidden: (_d = lmap.get("lastmodified")) !== null && _d !== void 0 ? _d : false }];
        this.cview.push(...sview);
        if (this.metaitems.size > 0) {
            const mitems = this.getMetadata();
            mitems.forEach((mi) => { var _a; return this.cview.push({ label: mi.name, id: mi.id, hidden: (_a = lmap.get(mi.id)) !== null && _a !== void 0 ? _a : false }); });
        }
    }
    clearMetadata() {
        this.metaitems.clear();
    }
    addMetadata(mt) {
        this.metaitems.set(mt.id, mt);
    }
    setShowColView(show) {
        this.showcolview = show;
    }
    setshowfilter(show) {
        this.showfilter = show;
    }
    getMetadata() {
        return Array.from(this.metaitems.values()).slice().sort((m1, m2) => m1.orderindex - m2.orderindex);
    }
    showSearchParentResult(objs) {
        let showparentwithcount = new Map();
        // now lets calcualte everything and we done here!!
        for (const obj of objs) {
            let count = 1;
            if (showparentwithcount.has(obj.parentid)) {
                const sj = showparentwithcount.get(obj.parentid);
                if (sj !== undefined) {
                    count = sj + 1;
                }
            }
            showparentwithcount.set(obj.parentid, count);
        }
        this.projecttreestate.hideOrShowItems(ROOTFolder, false);
        for (const [k, count] of showparentwithcount) {
            this.projecttreestate.hideOrShowItems(k, false);
            this.projecttreestate.updateCount(k, count);
            const folder = this.folders.get(k);
            if (folder !== undefined) {
                let parent = folder.parentid;
                while (parent !== ROOTFolder) {
                    this.projecttreestate.hideOrShowItems(parent, false);
                    if (!showparentwithcount.has(parent)) {
                        this.projecttreestate.updateCount(k, 0);
                    }
                    const folder = this.folders.get(parent);
                    if (folder === undefined) {
                        break;
                    }
                    parent = folder.parentid;
                }
            }
        }
    }
    async downloadParentForObjects(ids) {
        const req = {
            letrid: this.activeletrid,
            ids: ids,
            reqid: this.searchterm
        };
        Apphandler.sendMessage("getobjectparents", req);
    }
    setFoundMsg(msg) {
        this.foundmsg = msg;
    }
    showHome(clearsel = true) {
        this.setActiveFolderId(ROOTFolder);
    }
    performSearch() {
        if (!this.searchterm.trim() && this.filterdialogstate.valuesbyid.size === 0) {
            return;
        }
        this.setshowfilter(false);
        this.searchstore.clear();
        const fil = [];
        if (this.filterdialogstate.valuesbyid.size > 0) {
            for (const [k, val] of this.filterdialogstate.valuesbyid) {
                fil.push(Object.assign(Object.assign({}, val), { id: k }));
            }
        }
        this.setSearchProgess("Searching encrypted database...");
        this.setSearchFoundMessage("");
        this.setSearchActive(true);
        this.setShowSearchResult(true);
        this.setSearching(true);
        const req = {
            letrid: this.activeletrid,
            searchtext: this.searchterm,
            type: SearchDataType.DriveName,
            mfilter: fil
        };
        Apphandler.sendMessage("searchdrive", req);
    }
    performSearch_old() {
        if (!this.searchterm.trim()) {
            return;
        }
        this.searchstore.clear();
        this.setSearchProgess("Searching encrypted database...");
        this.setSearchFoundMessage("");
        this.setSearchActive(true);
        this.setShowSearchResult(true);
        this.setSearching(true);
        const req = {
            letrid: this.activeletrid,
            searchtext: this.searchterm,
            type: SearchDataType.DriveName,
            mfilter: []
        };
        Apphandler.sendMessage("searchdrive", req);
    }
    setSearching(searching) {
        this.searching = searching;
    }
    setSearchActive(searching) {
        this.searchactive = searching;
    }
    setSearchTerm(searching) {
        this.searchterm = searching;
    }
    setSearchFoundMessage(msg) {
        this.foundmsg = msg;
    }
    setSearchProgess(msg) {
        this.searchprogressmessage = msg;
    }
    addSearchResult(res) {
        this.searchstore.set(res.id, res);
    }
    setLoadingMoreSearch(loading) {
        this.loadingmoresearch = loading;
    }
    setShowAddLinkBtn(show) {
        this.showaddlinkbtn = show;
    }
    resetSearch() {
        this.setSearching(false);
        this.setSearchActive(false);
        this.setSearchTerm("");
        this.searchstore.clear();
        this.setSearchProgess("");
        this.setSearchFoundMessage("");
        this.setShowSearchResult(false);
        this.setLoadingMoreSearch(false);
        this.setActiveFolderId("");
        this.projecttreestate.showAll();
        this.projecttreestate.clearSelected();
        this.projecttreestate.setActiveItem("");
        this.folders.forEach((f) => {
            if (f.id !== ROOTFolder) {
                this.projecttreestate.updateCount(f.id, f.childrencount);
            }
        });
        this.projecttreestate.updateCount(this.projecttreestate.ROOTID, 0);
    }
    setActiveView(view) {
        this.activeview = view;
    }
    setHome() {
        this.projecttreestate.reset();
        const nodes = [];
        this.folders.forEach((f) => {
            const fobj = f;
            this.addFolder(fobj);
            const treenode = {
                id: f.id,
                children: [],
                label: f.name,
                parentid: f.parentid,
                displaycount: fobj.childrencount,
                color: fobj.color
            };
            nodes.push(treenode);
        });
        nodes.push({
            id: ROOTFolder,
            label: 'Home',
            children: [],
            parentid: this.projecttreestate.ROOTID
        });
        this.projecttreestate.setNodes(nodes);
        this.projecttreestate.setExpandedNode(ROOTFolder, true);
    }
    setShowSearchResult(show) {
        this.showsearchresult = show;
    }
    setActiveFolderId(id) {
        if (id === this.activefolderid) {
            return;
        }
        this.setShowSearchResult(false);
        this.setShowAddLinkBtn(false);
        this.documentTableState.clearRows();
        this.activefolderid = id;
        this.loadFolderContent();
    }
    dofilterFolders() {
        if (this.atimeout) {
            clearTimeout(this.atimeout);
        }
        this.atimeout = setTimeout(() => {
            if (!this.filterfolderterm.trim()) {
                this.projecttreestate.showAll();
                return;
            }
            // lets try filtering these items now!!
            const items = Array.from(this.folders.values()).filter((fol) => fol.name.toLowerCase().indexOf(this.filterfolderterm.trim()) !== -1);
            this.projecttreestate.hideAll();
            if (items.length === 0) {
            }
            else {
                this.projecttreestate.hideOrShowItems(ROOTFolder, false);
                // lets show these items and their parent
                for (const item of items) {
                    this.projecttreestate.hideOrShowItems(item.id, false);
                    let parent = item.parentid;
                    while (parent !== ROOTFolder) {
                        const pf = this.folders.get(parent);
                        if (pf === undefined) {
                            break;
                        }
                        this.projecttreestate.hideOrShowItems(parent, false);
                        parent = pf === null || pf === void 0 ? void 0 : pf.parentid;
                    }
                }
            }
        }, 50);
    }
    setFilterFolderTerm(term) {
        this.filterfolderterm = term;
        this.dofilterFolders();
    }
    setShow(show) {
        this.show = show;
    }
    setDragging(dragging) {
        this.dragging = dragging;
    }
    setLeft(left) {
        this.left = left;
    }
    setTop(top) {
        this.top = top;
    }
    getProjectObject(id) {
        return this.projectsobject.get(id);
    }
    getObjects() {
        let objs;
        if (this.searchactive && this.showsearchresult) {
            objs = Array.from(this.searchstore.values());
        }
        else {
            objs = Array.from(this.projectsobject.values());
        }
        return objs.sort((a, b) => {
            if (a.type !== b.type) {
                if (a.type === ProjectObjectType.Folder) {
                    return -1;
                }
                if (b.type === ProjectObjectType.Folder) {
                    return 1;
                }
            }
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
    }
    setWidth(width) {
        this.width = width;
    }
    addProjectObjectsByFolder(objs, folderid) {
        this.projectobjectsByFolderId.set(folderid, objs);
    }
    addProjectObjects(objs) {
        const drows = [];
        objs.forEach((ob, index) => {
            let add = true;
            if (this.searchactive) {
                const index = this.searchmatches.indexOf(ob.id);
                if (index > -1) {
                    add = true;
                }
                else {
                    add = false;
                }
            }
            if (add) {
                const robj = this.makeObjectForTable(ob);
                if (robj !== undefined) {
                    robj.rowindex = index;
                    drows.push(robj);
                }
            }
        });
        this.documentTableState.addRows(drows);
    }
    makeObjectForTable(ob) {
        this.projectsobject.set(ob.id, ob);
        if (ob.type !== ProjectObjectType.Folder) {
            const dcol = [];
            dcol.push({ id: ob.id + "_name", data: ob.name });
            dcol.push({
                id: ob.id + "_type", data: ob.type, type: ob.type,
                drafttype: ob.type === ProjectObjectType.Draft ? ob.drafttype : undefined
            });
            dcol.push({ id: ob.id + "_size", data: this.getSize(ob) });
            dcol.push({ id: ob.id + "_mod", data: this.getModified(ob) });
            console.log("METADATA ");
            console.log(this.getMetadata());
            this.getMetadata().forEach((mt) => {
                dcol.push({
                    id: "custom_" + mt.id,
                    data: "",
                });
            });
            return {
                rowindex: 0,
                row: dcol,
                id: ob.id
            };
        }
        return undefined;
    }
    getSize(ob) {
        if (ob.type === ProjectObjectType.Document) {
            const dob = ob;
            return formatBytes(dob.size);
        }
        else if (ob.type === ProjectObjectType.Folder) {
            const fob = ob;
            return fob.childrencount + " item" + (fob.childrencount > 1 ? 's' : '');
        }
        return "";
    }
    getModified(ob) {
        return DateLib.displayDate(ob.updatetime);
    }
    setLoadingFolder(loading) {
        this.loadingfolders = loading;
    }
    setLoadingFolderContent(loading) {
        this.loadingfoldercontent = loading;
    }
    loadFolderContent() {
        if (this.loadingfoldercontent || !this.activefolderid) {
            return;
        }
        this.setLoadingFolderContent(true);
        const req = {
            letrid: this.activeletrid,
            parentid: this.activefolderid,
            isChooser: true
        };
        Apphandler.sendMessage("getprojects", req);
    }
    loadMetaData() {
        const req = {
            id: this.activeletrid,
            isChooser: true
        };
        Apphandler.sendMessage("getmetadata", req);
    }
    loadFolders() {
        if (this.loadingfolders) {
            return;
        }
        this.setLoadingFolder(true);
        this.loadedfolder = 1;
        const req = { letrid: this.activeletrid, isChooser: true };
        Apphandler.sendMessage("getprojectfolder", req);
    }
    setFolders(folder) {
        const nodes = [];
        folder.forEach((f) => {
            const fobj = f;
            this.addFolder(fobj);
            const treenode = {
                id: f.id,
                children: [],
                label: f.name,
                parentid: f.parentid,
                displaycount: fobj.childrencount,
                color: fobj.color
            };
            nodes.push(treenode);
        });
        nodes.push({
            id: ROOTFolder,
            label: 'Home',
            children: [],
            parentid: this.projecttreestate.ROOTID
        });
        this.projecttreestate.setNodes(nodes);
        this.projecttreestate.setExpandedNode(ROOTFolder, true);
    }
    addFolder(folder) {
        this.folders.set(folder.id, folder);
    }
    setSelectionMode(sel) {
        this.selectionmode = sel;
    }
    reset() {
        this.setShowAddLinkBtn(false);
        this.loadedfolder = -1;
        this.activefolderid = "";
        this.projecttreestate.reset();
        this.folders.clear();
        this.setLoadingFolder(false);
        this.setLoadingFolderContent(false);
        this.projectobjectsByFolderId.clear();
        this.projectsobject.clear();
        this.searchactive = false;
        this.searchmatches = [];
        this.searchstore.clear();
        this.documentTableState.clearRows();
        this.documentTableState.setSelectId("");
        this.setActiveView("no-access");
        this.setshowfilter(false);
        this.setShowColView(false);
        this.hidecoilumn.clear();
        this.cview.splice(0, this.cview.length);
        this.metaitems.clear();
        this.setSelectionMode(false);
        this.setReportView(false);
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], ObjectChooserState.prototype, "projectsobject", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "searchterm", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ObjectChooserState.prototype, "folders", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ObjectChooserState.prototype, "searchstore", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], ObjectChooserState.prototype, "activeview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "width", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "left", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "top", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "dragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ObjectChooserState.prototype, "projectobjectsByFolderId", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "loadingfolders", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "loadingfoldercontent", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "showsearchresult", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "searchactive", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "filterfolderterm", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "foundmsg", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "loadingmoresearch", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "showaddlinkbtn", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "searching", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "searchprogressmessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "singlemode", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ObjectChooserState.prototype, "metaitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "showcolview", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], ObjectChooserState.prototype, "hidecoilumn", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "showfilter", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], ObjectChooserState.prototype, "cview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "activeitemid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "selectionmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "showfolderchooser", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectChooserState.prototype, "reportview", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setReportView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setShowFolderChooser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "hideCol", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "showCol", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setActiveItemid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "addColumnViews", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "clearMetadata", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "addMetadata", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setShowColView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setshowfilter", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setFoundMsg", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "showHome", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "performSearch", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "performSearch_old", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setSearching", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setSearchActive", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setSearchTerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setSearchFoundMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setSearchProgess", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "addSearchResult", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setLoadingMoreSearch", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setShowAddLinkBtn", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "resetSearch", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setActiveView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setShowSearchResult", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setActiveFolderId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setFilterFolderTerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, String]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "addProjectObjectsByFolder", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "addProjectObjects", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setLoadingFolder", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setLoadingFolderContent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "addFolder", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "setSelectionMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ObjectChooserState.prototype, "reset", null);
